import SimpleCrudForm from "../../components/crud/SimpleCrudForm";

export default function RideReviewForm() {
  return (
    <SimpleCrudForm
      title="Ride Review"
      apiPath="/ride-reviews"
      listRoute="/ride-reviews"
      initialData={{
        bookingId: "",
        driverId: "",
        customerId: "",
        rating: 5,
        reviewText: "",
        status: true,
      }}
      fields={[
        { name: "bookingId", label: "Booking Reference (number or UUID)" },
        { name: "driverId", label: "Driver UUID (optional — auto-filled from booking)" },
        { name: "customerId", label: "Customer UUID (optional — auto-filled from booking)" },
        { name: "rating", label: "Rating (1-5)", type: "number", required: true },
        { name: "reviewText", label: "Review Text", type: "textarea" },
        { name: "status", label: "Active", type: "checkbox" },
      ]}
    />
  );
}
